var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProcess3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Mesa_de_trabajo_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mesa_de_trabajo_1",
    "data-name": "Mesa de trabajo 1",
    clipPath: "url(#clip-Mesa_de_trabajo_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1190",
    "data-name": "Group 1190"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 105.349,
    height: 99.917,
    rx: 6.79,
    transform: "translate(332.223 65.949) rotate(-12.488)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M414.935,114.2a4.2,4.2,0,0,1-.681.2l-1.981.487-7.354,1.722-24.72,5.618-.2.046-.074-.194-1.492-3.97c-4.33-11.632-8.194-22.013-10.72-28.8l.175.1-6.6,1.408-1.762.354a3.51,3.51,0,0,1-.613.094,3.466,3.466,0,0,1,.6-.177l1.744-.431,6.573-1.544.128-.03L368,89.2c2.564,6.77,6.488,17.129,10.885,28.736l1.489,3.97-.275-.148,24.754-5.467,7.385-1.58,2-.4A4.158,4.158,0,0,1,414.935,114.2Z",
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M377.526,115.012a.637.637,0,0,1,.17-.058l.509-.134,1.981-.483,7.431-1.734,25.654-5.834-.179.234c-.208-4.492-.432-9.349-.664-14.376-.117-2.585-.232-5.126-.341-7.549l.288.221L382.1,92l-8.974,1.937-2.423.5-.63.119a.867.867,0,0,1-.218.026.806.806,0,0,1,.208-.07l.621-.161,2.4-.581,8.942-2.077,30.241-6.857.276-.063.013.283c.111,2.422.227,4.963.346,7.549.225,5.027.443,9.884.644,14.376l.009.193-.188.042-25.691,5.668-7.46,1.6-2,.409-.517.1A.565.565,0,0,1,377.526,115.012Z",
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M390.96,129.487c-.043.011-.114-.3-.382-.783a3.559,3.559,0,0,0-1.682-1.521,3.36,3.36,0,1,0,1.18,5.268,3.556,3.556,0,0,0,.872-2.093c.037-.552-.031-.863.012-.871a1.8,1.8,0,0,1,.175.876,3.551,3.551,0,0,1-.8,2.306A3.722,3.722,0,0,1,387,134.018a3.771,3.771,0,0,1-1.555-6.939,3.719,3.719,0,0,1,3.592-.2,3.548,3.548,0,0,1,1.707,1.744A1.811,1.811,0,0,1,390.96,129.487Z",
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M413.349,124.471c-.043.011-.114-.3-.383-.783a3.554,3.554,0,0,0-1.682-1.521,3.36,3.36,0,1,0,1.181,5.268,3.565,3.565,0,0,0,.872-2.093c.037-.552-.032-.863.012-.871a1.811,1.811,0,0,1,.174.876,3.546,3.546,0,0,1-.8,2.305,3.72,3.72,0,0,1-3.335,1.35,3.771,3.771,0,0,1-1.555-6.94,3.719,3.719,0,0,1,3.592-.2,3.548,3.548,0,0,1,1.707,1.744A1.809,1.809,0,0,1,413.349,124.471Z",
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M419.559,79.751a10.173,10.173,0,1,1-12.151-7.7A10.174,10.174,0,0,1,419.559,79.751Z",
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M414.192,77.061a9.229,9.229,0,0,1-.929,1.89c-.625,1.136-1.519,2.688-2.53,4.387l-1.089,1.808-.114.19-.191-.106a32.8,32.8,0,0,1-4.339-2.6,33.111,33.111,0,0,1,4.556,2.2l-.3.084,1.07-1.818c1.012-1.7,1.951-3.225,2.652-4.316A9.18,9.18,0,0,1,414.192,77.061Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M72.285,194.377c-1.845-6.534-10.337-5.9-10.337-5.9l.234,4.544c4.908-.847,7.959,4.906,7.959,4.906Z",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M196.975,118.944c9.85,2.984,15.979-8.376,15.979-8.376l-5.993-3.415c-2.93,6.959-12.768,6.154-12.768,6.154Z",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M278.741,179.926c-1.9-5.432-9.058-4.447-9.058-4.447l.437,3.833c4.11-.976,6.995,3.732,6.995,3.732Z",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M165.762,52.683c-1.906-5.432-9.058-4.448-9.058-4.448l.437,3.834c4.109-.976,6.994,3.731,6.994,3.731Z",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M80.421,122.192c-1.906-5.433-9.058-4.448-9.058-4.448l.437,3.833c4.109-.975,6.995,3.732,6.995,3.732Z",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M62.49,71.409c-5.681.932-5.955,8.147-5.955,8.147l3.851.236c-.246-4.216,4.891-6.239,4.891-6.239Z",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M21.592,240.394c9.85,2.984,15.978-8.377,15.978-8.377L31.577,228.6c-2.929,6.959-12.767,6.154-12.767,6.154Z",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M302.2,119.572c.666-4.561-4.774-6.52-4.774-6.52l-1.113,2.882c3.277.834,3.575,5.245,3.575,5.245Z",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M269.453,69.475c-3.841,2.549-1.667,7.907-1.667,7.907l2.889-1.1c-1.567-3,1.518-6.164,1.518-6.164Z",
    fill: "#ebebeb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M436.084,171.565l-13.3,39.166,39.326,7.815,2.263-41.359Z",
    fill: "#f5f5f5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M460.022,182.39c.046.019-.074.438-.442,1.123a11.449,11.449,0,0,1-1.98,2.632,10.751,10.751,0,0,1-4.168,2.6,11.731,11.731,0,0,1-6,.3,11.946,11.946,0,0,1-5.486-2.467,9.6,9.6,0,0,1-2.815-4.029,10.7,10.7,0,0,1-.676-3.226,2.666,2.666,0,0,1,.091-1.2,18.708,18.708,0,0,0,1.07,4.234,9.5,9.5,0,0,0,2.765,3.7,11.7,11.7,0,0,0,5.187,2.264,11.461,11.461,0,0,0,5.66-.226,10.821,10.821,0,0,0,4.016-2.327A20.979,20.979,0,0,0,460.022,182.39Z",
    fill: "#fff"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Desk"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M474.073,454.166c0,.144-102.568.261-229.062.261-126.538,0-229.084-.117-229.084-.261s102.546-.26,229.084-.26C371.505,453.906,474.073,454.023,474.073,454.166Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Screen"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 243.854,
    height: 190.896,
    transform: "translate(32.757 145.836)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M276.611,336.732c0-1.793-.086-75.734-.216-190.9l.216.215L32.778,146.1h-.021l.26-.26c-.009,68.838-.018,133.934-.026,190.9l-.234-.234,243.854.234-243.854.234h-.234v-.234c-.008-56.962-.017-122.058-.026-190.9v-.261h.281l243.833.045h.216v.216C276.7,261,276.613,334.941,276.611,336.732Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M93.093,254.843H90.169v-.761H96.9v.761H93.973v7.56h-.88Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M103.872,258.778V262.4h-.844v-3.542a1.746,1.746,0,0,0-1.878-2,2.05,2.05,0,0,0-2.188,2.258V262.4h-.843v-8.82h.843v3.662A2.643,2.643,0,0,1,101.3,256.1,2.394,2.394,0,0,1,103.872,258.778Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M110.882,258.528V262.4h-.808v-.975a2.348,2.348,0,0,1-2.152,1.034c-1.414,0-2.282-.737-2.282-1.818,0-.963.618-1.772,2.413-1.772h1.985v-.379c0-1.071-.606-1.653-1.771-1.653a3.183,3.183,0,0,0-2.08.737l-.38-.63a3.968,3.968,0,0,1,2.543-.844A2.221,2.221,0,0,1,110.882,258.528Zm-.844,2V259.5h-1.961c-1.213,0-1.605.476-1.605,1.118,0,.725.583,1.176,1.581,1.176A2,2,0,0,0,110.038,260.525Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M118.926,258.778V262.4h-.843v-3.542a1.746,1.746,0,0,0-1.878-2,2.05,2.05,0,0,0-2.188,2.258V262.4h-.844v-6.252h.809V257.3a2.626,2.626,0,0,1,2.377-1.2A2.394,2.394,0,0,1,118.926,258.778Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M123.536,259.265l-1.474,1.355V262.4h-.844v-8.82h.844v5.979l3.732-3.411h1.046l-2.674,2.555,2.924,3.7h-1.034Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M127.3,261.69l.381-.666a3.777,3.777,0,0,0,2.222.7c1.189,0,1.677-.4,1.677-1.022,0-1.628-4.054-.344-4.054-2.817,0-1.022.88-1.783,2.473-1.783a4.225,4.225,0,0,1,2.211.583l-.369.677a3.206,3.206,0,0,0-1.842-.535c-1.13,0-1.629.44-1.629,1.035,0,1.687,4.053.416,4.053,2.816,0,1.082-.95,1.783-2.579,1.783A4.185,4.185,0,0,1,127.3,261.69Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M138.15,254.843v3.269h4.3v.76h-4.3V262.4h-.879v-8.321h5.705v.761Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M143.771,259.277a3.18,3.18,0,1,1,3.185,3.185A3.075,3.075,0,0,1,143.771,259.277Zm5.5,0a2.326,2.326,0,1,0-2.318,2.436A2.281,2.281,0,0,0,149.274,259.277Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M155,256.1v.82c-.072,0-.143-.012-.2-.012a2.023,2.023,0,0,0-2.1,2.306V262.4h-.843v-6.252h.808v1.224A2.358,2.358,0,0,1,155,256.1Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M162.759,259.527V262.4h-.867v-2.876l-3.329-5.445h.94l2.852,4.671,2.853-4.671h.879Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M165.931,259.277a3.18,3.18,0,1,1,3.185,3.185A3.075,3.075,0,0,1,165.931,259.277Zm5.5,0a2.326,2.326,0,1,0-2.318,2.436A2.281,2.281,0,0,0,171.434,259.277Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M179.645,256.151V262.4h-.808v-1.141a2.488,2.488,0,0,1-2.247,1.2,2.422,2.422,0,0,1-2.639-2.686v-3.625h.844v3.542a1.75,1.75,0,0,0,1.878,2.009,2.033,2.033,0,0,0,2.128-2.271v-3.28Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M185.157,256.1v.82c-.071,0-.142-.012-.2-.012a2.023,2.023,0,0,0-2.1,2.306V262.4h-.844v-6.252h.809v1.224A2.357,2.357,0,0,1,185.157,256.1Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M189.327,258.243a4.371,4.371,0,1,1,4.374,4.231A4.188,4.188,0,0,1,189.327,258.243Zm7.857,0a3.5,3.5,0,1,0-3.483,3.447A3.371,3.371,0,0,0,197.184,258.243Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M203,256.1v.82c-.071,0-.142-.012-.2-.012a2.023,2.023,0,0,0-2.1,2.306V262.4h-.843v-6.252h.808v1.224A2.358,2.358,0,0,1,203,256.1Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M210.17,253.583v8.82h-.808v-1.237a2.707,2.707,0,0,1-2.413,1.3,3.18,3.18,0,0,1,0-6.359,2.733,2.733,0,0,1,2.378,1.236v-3.756Zm-.832,5.694a2.326,2.326,0,1,0-2.317,2.436A2.286,2.286,0,0,0,209.338,259.277Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M217.965,259.538h-5.23a2.314,2.314,0,0,0,2.46,2.175,2.463,2.463,0,0,0,1.914-.82l.476.547a3.306,3.306,0,0,1-5.694-2.163,3.011,3.011,0,0,1,3.055-3.174,2.98,2.98,0,0,1,3.031,3.174C217.977,259.348,217.965,259.443,217.965,259.538Zm-5.23-.63h4.434a2.222,2.222,0,0,0-4.434,0Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M222.848,256.1v.82c-.072,0-.143-.012-.2-.012a2.023,2.023,0,0,0-2.1,2.306V262.4H219.7v-6.252h.808v1.224A2.359,2.359,0,0,1,222.848,256.1Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M190.931,310.747H118.437A15.042,15.042,0,0,1,103.4,295.706h0a15.041,15.041,0,0,1,15.041-15.041h72.494a15.041,15.041,0,0,1,15.041,15.041h0A15.042,15.042,0,0,1,190.931,310.747Z",
    fill: "#e8505b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M142.275,292.283h2.568a2.949,2.949,0,1,1,0,5.875h-2.568Zm2.518,4.952a2.019,2.019,0,1,0,0-4.029h-1.427v4.029Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M148.781,295.22a3.167,3.167,0,1,1,3.164,3.022A3.008,3.008,0,0,1,148.781,295.22Zm5.229,0a2.064,2.064,0,1,0-2.065,2.064A2,2,0,0,0,154.01,295.22Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M161.481,292.283v5.875h-.9l-3.24-3.978v3.978h-1.082v-5.875h.9l3.239,3.978v-3.978Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M167.459,297.243v.915h-4.406v-5.875h4.288v.915h-3.2v1.527h2.836v.9h-2.836v1.62Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M156.7,218.985A19.382,19.382,0,1,1,176.086,199.6,19.4,19.4,0,0,1,156.7,218.985Zm0-36.764A17.382,17.382,0,1,0,174.086,199.6,17.4,17.4,0,0,0,156.7,182.221Z",
    fill: "#e8505b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M155.3,205.576a1,1,0,0,1-.661-.249c-1.695-1.492-4.594-4.078-4.967-4.636a1,1,0,0,1,1.653-1.126c.27.339,2.108,2.021,3.951,3.655l9.814-9.315a1,1,0,1,1,1.377,1.45L155.986,205.3A1,1,0,0,1,155.3,205.576Z",
    fill: "#e8505b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M276.611,164.485c0,.143-54.456.26-121.615.26-67.183,0-121.627-.117-121.627-.26s54.444-.261,121.627-.261C222.155,164.224,276.611,164.341,276.611,164.485Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 1.415,
    cy: 1.415,
    r: 1.415,
    transform: "translate(39.972 153.482)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 1.415,
    cy: 1.415,
    r: 1.415,
    transform: "translate(45.252 153.482)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M53.282,154.9a1.415,1.415,0,1,1-1.415-1.416A1.415,1.415,0,0,1,53.282,154.9Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Your_order_is_fulfilled",
    "data-name": "Your order is fulfilled",
    transform: "translate(63 245)",
    fill: "#0d0d0d",
    fontSize: 20,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Your"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontFamily: "Kailasa"
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "order"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontFamily: "Kailasa"
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "is"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontFamily: "Kailasa"
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "fulfilled")))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M436.917,274.085s12.136-7.384,14.871-5.214c3.948,3.131,5.264,8.418,5.264,8.418s6.41-24.45,12.527-23.522c3.508.532,1.787,3.265.214,6.7-1.46,3.187-3.951,14.884-3.951,14.884s11.6-13.761,15.008-13.513c2.637.193,3.016,2.512-.777,6.232s-10.094,15.438-10.094,15.438,8.125-7.575,11.481-7.616c2.677-.033,4.406,1.826.942,4.834s-8.707,5.264-11.5,10.7c-3.447,6.707-10.8,23.424-10.8,23.424l-25.725-9.107s-4.187-17.065-4.354-21.211c0,0,.353-8.762.3-10.322s4.088-1.96,5.344,1.035.685,6.137,1.2,8.129,1.416,3.838,2.872,4.729,5.163.952,6.11-.15a15.765,15.765,0,0,0,2.344-6.277,28.483,28.483,0,0,0-.072-5.086S437.438,280.933,436.917,274.085Z",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M147.875,353.71,130,347.014s-18.2-10.655-21.568-6.871a3.737,3.737,0,0,0-5.2,2.123c-.927,2.225,2.131,5.454,2.131,5.454s-.952.965.555,4.231S124.7,365.518,124.7,365.518s22.46,12.248,31.541,18.106l15.671-21.312-2.179-.814s-1.294-10.62-5.641-13.453c-4.731-3.081-10.438-11.419-11.694-14.686s-7.286-1.758-6.281,5.025,6.281,8.542,5.778,13.065S147.875,353.71,147.875,353.71Z",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M120.472,356.189a74.288,74.288,0,0,1-7.777-4.061,73.85,73.85,0,0,1-7.523-4.515,74.24,74.24,0,0,1,7.778,4.061A73.9,73.9,0,0,1,120.472,356.189Z",
    fill: "#eb996e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M129.2,351.163a23.294,23.294,0,0,1-3.208-1.277c-1.954-.85-4.636-2.071-7.536-3.553a82.052,82.052,0,0,1-7.241-4.137c-.89-.59-1.6-1.079-2.074-1.448s-.727-.576-.706-.6a32.59,32.59,0,0,1,2.975,1.74c1.827,1.085,4.4,2.508,7.284,3.987s5.539,2.747,7.452,3.681A22.124,22.124,0,0,1,129.2,351.163Z",
    fill: "#eb996e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M132.957,361.01a11.381,11.381,0,0,1-1.584-.86l-4.213-2.515-.047-.028-.027-.057a59.451,59.451,0,0,0-3.034-5.81,14.15,14.15,0,0,0-2.274-3.005,2.87,2.87,0,0,0-3.522-.265,1.76,1.76,0,0,0-.561.513.309.309,0,0,1,.041.119l.072.222c.045.147.1.3.156.446.217.6.453,1.184.683,1.762l1.368,3.338,2.418,5.766-.033-.052c1.469,1.721,2.684,3.145,3.594,4.213l.96,1.17a1.855,1.855,0,0,1,.306.435c-.015.013-.15-.111-.393-.359l-1.04-1.1-3.725-4.1-.019-.021-.014-.031c-.744-1.668-1.594-3.605-2.5-5.736l-1.393-3.336c-.234-.58-.472-1.166-.695-1.775-.056-.152-.114-.3-.164-.465l-.077-.239a1.611,1.611,0,0,1-.052-.357,1.131,1.131,0,0,1,.364-.532,3.346,3.346,0,0,1,.427-.323,3.483,3.483,0,0,1,2.155-.554,3.446,3.446,0,0,1,1.98.868,14.221,14.221,0,0,1,2.355,3.144,53.568,53.568,0,0,1,2.969,5.909l-.074-.085,4.123,2.658A11.584,11.584,0,0,1,132.957,361.01Z",
    fill: "#eb996e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M150.879,361.182a10.936,10.936,0,0,1-2.2-.538,21.792,21.792,0,0,0-5.285-.933,9.672,9.672,0,0,0-5.1,1.248,20.174,20.174,0,0,0-1.763,1.353,4.041,4.041,0,0,1,1.564-1.663,9.123,9.123,0,0,1,5.3-1.459,17.725,17.725,0,0,1,5.384,1.1A8.886,8.886,0,0,1,150.879,361.182Z",
    fill: "#eb996e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M149.535,356.461c.119.089-.326.862-.757,1.855s-.707,1.842-.854,1.814-.089-.968.377-2.023S149.427,356.373,149.535,356.461Z",
    fill: "#eb996e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M252.564,271.479c1.233-8.425,11.043-20.505,19.725-20.518a22.417,22.417,0,0,1-.186-24.646c3.35-5.014,8.752-8.7,11.043-14.256,2.592-6.287.6-13.39.85-20.167.362-9.92,5.523-18.979,10.549-27.6,4.6-7.89,10.217-16.539,19.274-18.477,5.731-1.226,11.675.583,17.055,2.874,25.745,10.965,45.767,34.076,52.638,60.759,1.645,6.388,2.747,13.3,7.2,18.234,4.714,5.228,12.97,8.064,14.385,14.9,1.015,4.9-2.133,9.834-1.661,14.816.4,4.174,8.213,16.341,10.015,20.142,3.1,6.548,1.982,13.623-1.179,20.145s-11.207,12.876-18.346,14.652l-79.8-26.592c-7.508,4.274-14.987,20.808-23.606,21.825s-19.136,4.767-27.428-4.308C254.394,293.757,251.33,279.9,252.564,271.479Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M384.887,192.1c-.893,6.678.938,17.719,4.588,23.425,2.45,3.829,6.538,6.32,10.571,8.511s8.256,4.292,11.314,7.675,4.7,8.456,2.653,12.508c7.189,2.68,10.414,11.838,7.776,18.921s-9.869,11.848-17.424,13.263l-32.914-9.9-7.228-42,19-32.4",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M388.927,234.926a3.826,3.826,0,0,1,.643.28,18.391,18.391,0,0,1,1.8.934,23.86,23.86,0,0,1,5.769,4.809,26.522,26.522,0,0,1,3.074,4.269,26.908,26.908,0,0,1,2.4,5.6,24.216,24.216,0,0,1,.089,14.017l-.12-.3a24.37,24.37,0,0,1,5.355,4.069,24.944,24.944,0,0,1,7.178,14.655,24.045,24.045,0,0,1-2.356,13.17,24.839,24.839,0,0,1-5.4,7.273,20.165,20.165,0,0,1-1.916,1.559,5.349,5.349,0,0,1-.716.478,5.327,5.327,0,0,1,.652-.561c.447-.342,1.067-.893,1.841-1.623a25.634,25.634,0,0,0,5.212-7.286,23.9,23.9,0,0,0,2.212-12.955,24.641,24.641,0,0,0-7.07-14.342,24.036,24.036,0,0,0-5.237-3.988l-.181-.1.06-.2a23.92,23.92,0,0,0-.033-13.734,25.9,25.9,0,0,0-5.291-9.775,24.936,24.936,0,0,0-5.609-4.875c-.724-.494-1.353-.763-1.744-1.006A4,4,0,0,1,388.927,234.926Z",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M291.559,278.422s-14.707,4.473-19.863,11.972c-3.647,5.3-40.987,86.169-40.987,86.169L174.026,359.52,153.76,386.287l63.067,34.958a38.422,38.422,0,0,0,37.549-.166h0a38.418,38.418,0,0,0,15.141-15.662l16.036-30.724Z",
    fill: "#e8505b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M276.509,454.549,285.36,416.4l-6.706-27.7c-4.314-14.264-8.017-37.5-3.324-56.211l15.676-53.813,17.236-7.926,39.442-6.784c1.517.505,41.243,11.725,41.243,11.725a61.627,61.627,0,0,1,7.706,2.154l4.555,29.458-13.7,48.553-5.965,48.377,13.1,50.316Z",
    fill: "#e8505b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M273.579,335.863",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.02
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M365.993,339.421",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.02
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M299.3,274.861l11.438-5.119,51.549.718,12.192,7.077s-42.587,47-53.275,48.558C294.323,330.005,299.3,274.861,299.3,274.861Z",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M395.514,277.438s7.721,1.737,14.34,15.858,17.319,53.418,17.319,53.418l4.575-41.646,37.27,4.1L461.8,408.7s-13.19,19.127-35.252,17.362-50.072-71.505-50.072-71.505Z",
    fill: "#e8505b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M421.357,397.568a.9.9,0,0,1-.007-.242c.008-.19.017-.421.029-.7q.06-.994.163-2.708c.142-2.353.423-5.751.812-9.946.777-8.392,2.2-19.948,3.94-32.682s3.221-24.277,4.09-32.654c.437-4.187.773-7.578.977-9.924q.165-1.707.26-2.7c.033-.282.059-.512.081-.7a.828.828,0,0,1,.046-.238.852.852,0,0,1,.007.242l-.029.705q-.06.993-.163,2.708c-.142,2.352-.422,5.75-.812,9.945-.777,8.392-2.2,19.949-3.941,32.687s-3.22,24.272-4.089,32.649c-.437,4.187-.773,7.578-.977,9.925q-.165,1.707-.26,2.7c-.033.282-.059.512-.081.7A.827.827,0,0,1,421.357,397.568Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M231.353,398.04a2.7,2.7,0,0,1-.412-.744,21.831,21.831,0,0,1-.866-2.146,32.163,32.163,0,0,1-1.461-15.088,21.324,21.324,0,0,1,.438-2.272,2.715,2.715,0,0,1,.261-.81c.084.018-.142,1.2-.334,3.126a38.12,38.12,0,0,0,1.447,14.93C230.983,396.889,231.432,398.007,231.353,398.04Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M237.622,398.963a3.658,3.658,0,0,1-.657-.743,26.77,26.77,0,0,1-1.555-2.207A38.376,38.376,0,0,1,229.6,379.3a26.5,26.5,0,0,1-.151-2.7,3.682,3.682,0,0,1,.053-.99c.088,0,.152,1.4.463,3.642a44.514,44.514,0,0,0,5.763,16.562C236.871,397.77,237.693,398.911,237.622,398.963Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M281.746,310.038a4.915,4.915,0,0,1-.189.807l-.636,2.285c-.575,2.032-1.383,4.886-2.376,8.391a185.171,185.171,0,0,0-5.924,28.09,65.454,65.454,0,0,0,2.406,28.36c1.054,3.522,2.052,6.33,2.735,8.272q.5,1.4.787,2.236a4.856,4.856,0,0,1,.243.793,5.169,5.169,0,0,1-.341-.755q-.327-.822-.879-2.2c-.742-1.922-1.794-4.714-2.9-8.235a67.516,67.516,0,0,1-2.75-12.662,68.541,68.541,0,0,1,.178-15.864,172.471,172.471,0,0,1,6.087-28.132c1.033-3.537,1.916-6.384,2.537-8.348q.459-1.416.73-2.257A4.847,4.847,0,0,1,281.746,310.038Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M385.968,375.617a1.1,1.1,0,0,1-.135-.245l-.35-.739-1.3-2.864c-.551-1.249-1.256-2.765-2.007-4.553-.723-1.808-1.542-3.859-2.446-6.122-.88-2.278-1.727-4.818-2.7-7.522q-.638-2.059-1.317-4.254-.336-1.1-.682-2.227c-.215-.758-.4-1.534-.609-2.315a102.106,102.106,0,0,1-3.525-20.709,59.683,59.683,0,0,1,2.155-20.865,37,37,0,0,1,8.255-14.959,28.871,28.871,0,0,1,9.3-6.824,21.677,21.677,0,0,1,2.953-1.094l.789-.221a1.137,1.137,0,0,1,.273-.058,1.114,1.114,0,0,1-.259.109l-.771.27a25.708,25.708,0,0,0-2.9,1.178,29.484,29.484,0,0,0-9.117,6.888,37.014,37.014,0,0,0-8.067,14.848,59.873,59.873,0,0,0-2.1,20.7,103.587,103.587,0,0,0,3.469,20.616q.3,1.17.6,2.309l.669,2.224q.664,2.19,1.288,4.25c.951,2.7,1.775,5.245,2.631,7.528.877,2.27,1.671,4.327,2.371,6.14.725,1.8,1.4,3.323,1.924,4.584l1.208,2.9.3.76A1.113,1.113,0,0,1,385.968,375.617Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M371.763,330.535c-4.871,23.049-4.937,46.76,3.452,68.774.486,1.277,2.412,5.817,3.777,5.884,1.731.086,2.552-2.068,2.852-3.775.615-3.508.992-9.282,1.607-12.791.772-4.393,1.816-14.563,1.816-14.563s-4.03-9.223-5.8-14.169c-3.287-9.177-6.066-17.935-7.6-28.633"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M367.784,419.829a3.633,3.633,0,0,1-.387.6l-1.2,1.669q-.4.547-.877,1.2c-.335.427-.735.862-1.146,1.345a40.1,40.1,0,0,1-2.916,3.17l-1.791,1.755c-.629.6-1.352,1.157-2.063,1.77a58.623,58.623,0,0,1-4.778,3.626,61.412,61.412,0,0,1-25.422,9.908,58.868,58.868,0,0,1-5.972.564c-.939.029-1.844.111-2.716.092l-2.507-.08a39.8,39.8,0,0,1-4.292-.361c-.63-.077-1.218-.127-1.754-.214l-1.457-.291-2.01-.419a3.731,3.731,0,0,1-.693-.18,3.717,3.717,0,0,1,.715.078l2.023.322,1.458.244c.535.073,1.123.108,1.751.171a42.7,42.7,0,0,0,4.273.282l2.49.046c.866.009,1.765-.083,2.7-.122,1.868-.041,3.841-.347,5.921-.607a62.58,62.58,0,0,0,25.228-9.832c1.707-1.216,3.367-2.326,4.77-3.56.712-.6,1.436-1.142,2.067-1.735l1.8-1.718a42.68,42.68,0,0,0,2.955-3.1c.42-.471.829-.9,1.174-1.31l.908-1.167,1.272-1.607A3.8,3.8,0,0,1,367.784,419.829Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M359.65,404.576a4.377,4.377,0,0,1-.133,1.093,25.146,25.146,0,0,1-.7,2.916,34.754,34.754,0,0,1-10.64,16.421,25.23,25.23,0,0,1-2.376,1.828,4.478,4.478,0,0,1-.943.568c-.055-.077,1.223-.978,3.074-2.672a38.425,38.425,0,0,0,10.533-16.256C359.258,406.092,359.558,404.558,359.65,404.576Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M341.5,139.445a40.512,40.512,0,0,1,35.225,60.029c-2.292,4.169-5.589,8.116-10.118,9.569a83.511,83.511,0,0,0-25.334-64.857",
    fill: "#e8505b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M357.828,143.057c-2.072-4.308.146-9.7,3.841-12.732s8.508-4.26,13.158-5.37,9.467-2.263,13.244-5.194c-.545,7.49-2.406,15.2-7.254,20.932s-13.246,8.932-20.168,6.017",
    fill: "#e8505b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M362.631,147.991c-3.182,1.339-6.976.5-9.824-1.449a22.4,22.4,0,0,1-6.557-7.9,33.939,33.939,0,0,1-4.213-11.925,19.97,19.97,0,0,1,2.11-12.326c5.474,5.832,11.5,10.733,14.632,18.094,1.839,4.324,1.616,11.256-.356,15.521",
    fill: "#e8505b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M378.135,172.241a7.3,7.3,0,0,1,.273,1.391c.076.45.155,1,.205,1.649s.146,1.38.162,2.2a44.644,44.644,0,0,1-.1,5.735,46.227,46.227,0,0,1-3.244,13.636,44.707,44.707,0,0,1-2.493,5.166c-.382.723-.793,1.338-1.134,1.889s-.656,1.012-.926,1.38a7.373,7.373,0,0,1-.87,1.119,7.439,7.439,0,0,1,.7-1.231c.244-.383.537-.854.847-1.419s.7-1.186,1.06-1.914a51.056,51.056,0,0,0,2.37-5.168,49.568,49.568,0,0,0,3.212-13.5,50.907,50.907,0,0,0,.211-5.681c.008-.811-.056-1.542-.084-2.186s-.072-1.2-.117-1.649A7.511,7.511,0,0,1,378.135,172.241Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M375.013,145.422a7.375,7.375,0,0,1-1.108.882,12.081,12.081,0,0,1-3.611,1.4,28.145,28.145,0,0,1-12.77-.728l-.146-.038-.034-.149c-.066-.3-.138-.621-.21-.945a22.355,22.355,0,0,1-.33-7.438,12.671,12.671,0,0,1,2.1-5.705,10.543,10.543,0,0,1,2.967-2.833,8.174,8.174,0,0,1,1.347-.668,8.174,8.174,0,0,1-1.234.836,11.271,11.271,0,0,0-2.775,2.871,12.663,12.663,0,0,0-1.93,5.561,22.689,22.689,0,0,0,.365,7.272c.071.317.141.632.206.925l-.179-.187a29.38,29.38,0,0,0,12.549.875,13.264,13.264,0,0,0,3.586-1.217A7.56,7.56,0,0,1,375.013,145.422Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M379.109,132.463c.015.1-1.463.3-3.755.981a32.505,32.505,0,0,0-3.929,1.456,31.906,31.906,0,0,0-8.544,5.6,32.587,32.587,0,0,0-2.9,3.023c-1.538,1.83-2.317,3.1-2.4,3.051a4.044,4.044,0,0,1,.485-.931,21.2,21.2,0,0,1,1.627-2.353,28.266,28.266,0,0,1,2.862-3.142,29.535,29.535,0,0,1,8.678-5.687,28.142,28.142,0,0,1,4.022-1.37,21.077,21.077,0,0,1,2.807-.553A4.013,4.013,0,0,1,379.109,132.463Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M362.417,147.872c.017,0,0,.107-.039.3a4.31,4.31,0,0,1-.268.827,6.475,6.475,0,0,1-1.977,2.5,6.872,6.872,0,0,1-4.495,1.451,6.776,6.776,0,0,1-5.882-8.583,6.876,6.876,0,0,1,2.976-3.668,6.483,6.483,0,0,1,3.046-.942,4.29,4.29,0,0,1,.867.049c.2.03.3.055.3.072-.005.055-.418,0-1.146.081a6.8,6.8,0,0,0-2.866,1.052,6.639,6.639,0,0,0-2.714,3.5,6.37,6.37,0,0,0,5.453,7.959,6.634,6.634,0,0,0,4.245-1.267,6.819,6.819,0,0,0,2.016-2.293C362.269,148.262,362.364,147.857,362.417,147.872Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    "data-name": "Group 130"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_129",
    "data-name": "Group 129"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M350.293,148.122c-.048.05-.347-.544.127-1.324a2.261,2.261,0,0,1,1.187-.927,4.4,4.4,0,0,1,1.786-.187,8.18,8.18,0,0,1,4.243,1.265c-.055.144-1.9-.58-4.278-.746a2.879,2.879,0,0,0-2.636.806A2.636,2.636,0,0,0,350.293,148.122Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M344.147,114.4a12.367,12.367,0,0,0-1.527,4.278,29.607,29.607,0,0,0-.236,4.963,32.424,32.424,0,0,0,.532,6.054,30.022,30.022,0,0,0,4.271,10.124c.812,1.163,1.528,2.067,2.035,2.677s.823.915.8.945a14.26,14.26,0,0,1-3.133-3.407,28.118,28.118,0,0,1-4.482-10.235,30.662,30.662,0,0,1-.5-6.156,26.915,26.915,0,0,1,.354-5.029A10.07,10.07,0,0,1,343.4,115.4,3.621,3.621,0,0,1,344.147,114.4Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M349.329,126.26a7.791,7.791,0,0,1,1.406,1.709,29.608,29.608,0,0,1,2.656,4.634,27.942,27.942,0,0,1,1.757,5.047,7.608,7.608,0,0,1,.343,2.187c-.163.038-.842-3.271-2.573-7.017C351.2,129.069,349.188,126.358,349.329,126.26Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M347.637,132.49c.105-.089,1.789,1.614,3.995,3.593a30.708,30.708,0,0,1,3.859,3.754,25.854,25.854,0,0,1-4.209-3.369A18.28,18.28,0,0,1,347.637,132.49Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M373.808,155.951c0,.006-.045.054-.144.142l-.44.374a20.174,20.174,0,0,1-1.707,1.269,25.7,25.7,0,0,1-13.188,4.33,19.536,19.536,0,0,1-2.126-.009l-.576-.041a.717.717,0,0,1-.2-.028.743.743,0,0,1,.2-.014l.577,0c.5.013,1.224,0,2.116-.057a27.232,27.232,0,0,0,13.114-4.307c.749-.485,1.342-.9,1.737-1.209l.464-.343A.816.816,0,0,1,373.808,155.951Z",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M379.7,168.054a.815.815,0,0,1-.146.14l-.445.37c-.385.323-.97.758-1.714,1.262a28.706,28.706,0,0,1-13.1,4.723c-.895.087-1.623.126-2.126.123h-.578a.764.764,0,0,1-.2-.015.773.773,0,0,1,.2-.027l.576-.038c.5-.022,1.224-.083,2.113-.188a30.709,30.709,0,0,0,13.038-4.7c.751-.486,1.347-.9,1.746-1.2l.468-.339A.693.693,0,0,1,379.7,168.054Z",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M378.063,185.706a2.545,2.545,0,0,1-.424.312c-.278.193-.7.447-1.23.738a19.807,19.807,0,0,1-9.086,2.376c-.606.007-1.1-.009-1.433-.041a2.557,2.557,0,0,1-.523-.065,2.626,2.626,0,0,1,.526-.016c.337.007.825,0,1.426-.025a21.975,21.975,0,0,0,9.022-2.36c.536-.272.965-.505,1.255-.676A2.543,2.543,0,0,1,378.063,185.706Z",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M381.456,183.005a4.721,4.721,0,0,1-1.351.366,4.784,4.784,0,0,1-1.39.162,9.431,9.431,0,0,1,2.741-.528Z",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M371.533,203.76a9.281,9.281,0,0,1-4.523-.331c.015-.06,1.01.15,2.256.239S371.527,203.7,371.533,203.76Z",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M352.555,151.468a12.045,12.045,0,0,1-2.767,1.526,12.045,12.045,0,0,1,2.767-1.526Z",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M347.588,140.971a13.5,13.5,0,0,0-5.414,3.847,3.4,3.4,0,0,1,.574-.812,9.835,9.835,0,0,1,3.885-2.76A3.421,3.421,0,0,1,347.588,140.971Z",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M356.6,152.6a10.421,10.421,0,0,0-.769-5.95,2.762,2.762,0,0,1,.446.787,7.768,7.768,0,0,1,.555,4.289A2.746,2.746,0,0,1,356.6,152.6Z",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M387.538,119.982a12.154,12.154,0,0,1-1.1,1.168,22.2,22.2,0,0,1-3.459,2.661,43.9,43.9,0,0,1-5.75,2.973c-2.228.988-4.722,1.962-7.25,3.175a28.319,28.319,0,0,0-6.632,4.23,16.7,16.7,0,0,0-3.9,5.07,12.16,12.16,0,0,0-1.188,4.149c-.089,1.023-.016,1.593-.05,1.594,0,0-.019-.141-.034-.412a8.781,8.781,0,0,1,0-1.188,11.827,11.827,0,0,1,1.136-4.206,16.636,16.636,0,0,1,3.9-5.149,28.067,28.067,0,0,1,6.67-4.276c2.538-1.218,5.037-2.187,7.263-3.163a45.457,45.457,0,0,0,5.75-2.922,23.681,23.681,0,0,0,3.482-2.6c.377-.349.665-.625.852-.822S387.538,119.982,387.538,119.982Z",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M384.834,131.851a1.225,1.225,0,0,1-.133.226l-.417.628c-.359.546-.921,1.309-1.653,2.222a39.541,39.541,0,0,1-14.325,11.12c-1.066.483-1.944.839-2.563,1.051l-.711.248a1.209,1.209,0,0,1-.252.072,1.273,1.273,0,0,1,.238-.112l.7-.284c.608-.235,1.476-.61,2.53-1.108a41.74,41.74,0,0,0,14.273-11.08c.744-.9,1.323-1.645,1.7-2.176l.448-.6A1.23,1.23,0,0,1,384.834,131.851Z",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M343.093,117.8a19.089,19.089,0,0,1,3.031,1.6,25.093,25.093,0,0,1,10.126,12.779,19.207,19.207,0,0,1,.87,3.317,1,1,0,0,1-.076-.227c-.055-.205-.114-.421-.177-.658a23.911,23.911,0,0,0-.756-2.382,26.048,26.048,0,0,0-10.068-12.706,23.57,23.57,0,0,0-2.147-1.28l-.6-.323A1.093,1.093,0,0,1,343.093,117.8Z",
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_256",
    "data-name": "Group 256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_252",
    "data-name": "Group 252"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M292.942,155.4c.391,5.3-3.109,10.035-6.636,14.011s-7.451,8.12-8.213,13.38c-1.351,9.321,7.775,17.976,5.893,27.2-1.009,4.946-5.059,8.92-5.781,13.916-.7,4.832,1.892,9.562,5.1,13.241s6.929,3.141,9.768,7.113a39.923,39.923,0,0,0,12.318,10.948c10.228,5.6,22.5-2.5,27.437-3.957",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M370.289,177.125c4.715-2.052,5.085-18.947-6.743-20.9-4.745-.782-8.7-3.1-12.686-5.783-3.532-2.377-4.58-8.411-7.57-11.442a29.6,29.6,0,0,0-49.783,13.581c-1.718,6.846-.545,14.939,4.851,19.489,6.263,5.279,15.549,4.107,23.573,2.464s17.108-3.262,23.808,1.451c4.041,2.842,6.357,7.465,8.827,11.743s5.57,8.647,10.241,10.255c0,0,3.557,8.358.653,14.176s3.414-4.1,3.414-4.1,11.517-20.479,1.415-30.931",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_249",
    "data-name": "Group 249"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_248",
    "data-name": "Group 248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_247",
    "data-name": "Group 247"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_246",
    "data-name": "Group 246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_229",
    "data-name": "Group 229"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_228",
    "data-name": "Group 228"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_167",
    "data-name": "Group 167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M310.374,295.706c-.065-11.031,0-42,0-41.949,0,0-17.521-2.949-21.1-25.826-1.781-11.377-1.168-30.024-.174-45.264.9-13.718,10.022-30.531,23.689-29.055L355.451,164.5a8.043,8.043,0,0,1,7.178,8.174h0l-2.6,105.953Z",
    fill: "#ffbe9d"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_179",
    "data-name": "Group 179"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_177",
    "data-name": "Group 177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_176",
    "data-name": "Group 176"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    "data-name": "Group 175"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_172",
    "data-name": "Group 172"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M296.359,195.736a2.934,2.934,0,0,0,2.822,2.966,2.805,2.805,0,0,0,3.029-2.638,2.934,2.934,0,0,0-2.818-2.967A2.808,2.808,0,0,0,296.359,195.736Z",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    "data-name": "Group 180"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M293.121,192.376c.363.384,2.589-1.256,5.745-1.241,3.153-.029,5.465,1.6,5.809,1.214.168-.171-.2-.862-1.208-1.6a8.05,8.05,0,0,0-4.649-1.444,7.73,7.73,0,0,0-4.573,1.465C293.273,191.514,292.943,192.205,293.121,192.376Z",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_199",
    "data-name": "Group 199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_198",
    "data-name": "Group 198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_197",
    "data-name": "Group 197"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_196",
    "data-name": "Group 196"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_195",
    "data-name": "Group 195"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_194",
    "data-name": "Group 194"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_193",
    "data-name": "Group 193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_192",
    "data-name": "Group 192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_191",
    "data-name": "Group 191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_190",
    "data-name": "Group 190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M324.143,197.406c.363.383,2.592-1.256,5.745-1.241,3.153-.03,5.466,1.6,5.809,1.213.168-.171-.2-.862-1.208-1.6a8.039,8.039,0,0,0-4.648-1.445,7.741,7.741,0,0,0-4.574,1.465C324.3,196.543,323.966,197.234,324.143,197.406Z",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_201",
    "data-name": "Group 201"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_200",
    "data-name": "Group 200"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M312.637,216.415c.016-.18-1.946-.523-5.124-.937-.8-.085-1.568-.247-1.7-.8a4.107,4.107,0,0,1,.544-2.388q1.143-2.922,2.4-6.131c3.329-8.73,5.74-15.909,5.388-16.04s-3.338,6.839-6.667,15.569q-1.2,3.229-2.3,6.168a4.674,4.674,0,0,0-.425,3.162,2.027,2.027,0,0,0,1.323,1.182,5.515,5.515,0,0,0,1.369.193C310.64,216.575,312.625,216.594,312.637,216.415Z",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_216",
    "data-name": "Group 216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    "data-name": "Group 215"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_211",
    "data-name": "Group 211"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M310.374,253.757a58.18,58.18,0,0,0,30.646-8.1c-.257.055-8.433,15.9-30.349,13.5Z",
    fill: "#eb996e"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_217",
    "data-name": "Group 217"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M313.548,225.525c-.377-1.942,1.908-2.572,3.588-3.616s2.646-2.432,4.22-1.234A6.138,6.138,0,0,1,323.3,223.4a4.3,4.3,0,0,1,.315,2.234,4.353,4.353,0,0,1-1.406,2.336,6.657,6.657,0,0,1-3.426,1.792,4.77,4.77,0,0,1-3.71-.872,3.741,3.741,0,0,1-1.414-3.461",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_226",
    "data-name": "Group 226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_225",
    "data-name": "Group 225"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_224",
    "data-name": "Group 224"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_223",
    "data-name": "Group 223"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_222",
    "data-name": "Group 222"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_221",
    "data-name": "Group 221"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_220",
    "data-name": "Group 220"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_219",
    "data-name": "Group 219"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_218",
    "data-name": "Group 218"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M321.921,218.618c-.513-.031-.528,3.4-3.466,5.82s-6.583,2.04-6.61,2.519c-.049.215.811.667,2.352.712a8.525,8.525,0,0,0,5.519-1.909,7.428,7.428,0,0,0,2.685-4.88C322.535,219.448,322.155,218.6,321.921,218.618Z",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_237",
    "data-name": "Group 237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_236",
    "data-name": "Group 236"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_235",
    "data-name": "Group 235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_234",
    "data-name": "Group 234"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_233",
    "data-name": "Group 233"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_232",
    "data-name": "Group 232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_231",
    "data-name": "Group 231"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_230",
    "data-name": "Group 230"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M323.674,190.355c.31.858,3.462.459,7.163.913,3.712.381,6.7,1.471,7.188.7.22-.368-.3-1.176-1.5-2.009a12.545,12.545,0,0,0-10.933-1.231C324.227,189.274,323.542,189.947,323.674,190.355Z",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_245",
    "data-name": "Group 245"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_244",
    "data-name": "Group 244"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_243",
    "data-name": "Group 243"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_242",
    "data-name": "Group 242"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_241",
    "data-name": "Group 241"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_240",
    "data-name": "Group 240"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_239",
    "data-name": "Group 239"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M293.561,181.46c.553.718,2.729-.021,5.343-.051,2.614-.12,4.828.492,5.339-.256.224-.364-.123-1.082-1.089-1.763a7.739,7.739,0,0,0-8.607.247C293.622,180.372,293.317,181.109,293.561,181.46Z",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_251",
    "data-name": "Group 251"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_250",
    "data-name": "Group 250"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M365.13,241c-6.289,1.268-6.85-1.933-11.549-6.3a20.656,20.656,0,0,1-6.321-17.424c.711-5.617,3.74-11.331,1.792-16.647-2.574-7.029-12.427-9.192-15.041-16.205-1.52-4.077-.156-8.845-1.878-12.84-1.62-3.757-5.572-5.921-9.419-7.311s-7.972-2.352-11.2-4.862-5.245-7.249-3.161-10.77a216.76,216.76,0,0,1,49.973,12.142c3.732,1.394,7.653,3.07,9.86,6.387,2.335,3.51,2.223,8.045,2.026,12.257l-2.874,61.6",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_255",
    "data-name": "Group 255"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_254",
    "data-name": "Group 254"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_253",
    "data-name": "Group 253"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M379.7,233.329c.014.01.1-.086.25-.285a8.04,8.04,0,0,0,.631-.914,12.161,12.161,0,0,0,1.507-4,14.062,14.062,0,0,0-.368-6.754,12.914,12.914,0,0,0-5.322-7.158c-2.713-1.913-6.246-3.246-8.491-6.29a6.863,6.863,0,0,1-1.242-5.37,30.652,30.652,0,0,1,1.99-5.934,17.066,17.066,0,0,0-.294-13.654,14.958,14.958,0,0,0-4.641-5.765,18.121,18.121,0,0,0-7.014-2.908c-2.477-.565-4.948-.893-7.241-1.585A14.126,14.126,0,0,1,343.4,169.4a10.073,10.073,0,0,1-2.63-6,51.4,51.4,0,0,0-1.077-6.649,22.919,22.919,0,0,0-6.172-10.819,18.07,18.07,0,0,0-9.716-4.82,14.437,14.437,0,0,0-8.84,1.338,13.971,13.971,0,0,0-5.114,4.427,11.831,11.831,0,0,0-1.789,3.881,6.073,6.073,0,0,0-.222,1.471,14.536,14.536,0,0,1,2.328-5.123A13.782,13.782,0,0,1,323.7,141.81a17.428,17.428,0,0,1,9.249,4.718A22.191,22.191,0,0,1,338.8,156.98a51.465,51.465,0,0,1,1.024,6.559,11.018,11.018,0,0,0,2.877,6.548,15.037,15.037,0,0,0,6.478,3.584c2.4.725,4.881,1.051,7.306,1.607a17.2,17.2,0,0,1,6.645,2.734,14,14,0,0,1,4.34,5.375,16.152,16.152,0,0,1,.321,12.909,30.909,30.909,0,0,0-2,6.13,7.728,7.728,0,0,0,1.441,5.994c2.495,3.28,6.132,4.558,8.765,6.386a12.375,12.375,0,0,1,5.186,6.74,13.925,13.925,0,0,1,.518,6.517A15.337,15.337,0,0,1,379.7,233.329Z",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_262",
    "data-name": "Group 262"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_259",
    "data-name": "Group 259"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_257",
    "data-name": "Group 257"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M349.947,210.6a57.856,57.856,0,0,0-2.672,38.142c1.035,3.741,2.465,7.62,1.581,11.4-.958,4.092-4.379,7.052-6.875,10.433a25.751,25.751,0,0,0,7.892,37.627c.661-3.761,4.16-6.325,7.611-7.96s7.263-2.848,9.895-5.615,3.376-7.839.317-10.124c8.8-2.3,13.793-12.757,11.94-21.666s-9.1-15.947-17.339-19.806",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_258",
    "data-name": "Group 258"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M359.334,299.409c-1.574.864-3.1,1.635-3.3,3.42-.228,2.1,1.781,5.771,2.5,7.751a10.767,10.767,0,0,1-14.073,13.7c2.817.216,5.207-2.533,5.458-5.348s-1.114-5.53-2.793-7.8-3.713-4.292-5.137-6.733c-2.9-4.968-7.2-18.484-3.89-26.054",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_261",
    "data-name": "Group 261"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_260",
    "data-name": "Group 260"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M367.338,284.855a3.644,3.644,0,0,1,.541-.457c.367-.281.9-.707,1.569-1.27a34.955,34.955,0,0,0,5.141-5.317,26.715,26.715,0,0,0,4.872-9.717,21.9,21.9,0,0,0-.645-13.132,19.418,19.418,0,0,0-3.619-5.844c-1.471-1.693-3.075-3.168-4.579-4.6a47.244,47.244,0,0,1-4.1-4.272,18.341,18.341,0,0,1-2.69-4.424,11.685,11.685,0,0,1-.882-7.349,7.787,7.787,0,0,1,.748-1.9,3.664,3.664,0,0,1,.387-.594,13.114,13.114,0,0,0-.937,2.534,11.739,11.739,0,0,0,1.022,7.157,18.259,18.259,0,0,0,2.686,4.3,47.993,47.993,0,0,0,4.1,4.2c1.51,1.421,3.132,2.9,4.634,4.615a19.785,19.785,0,0,1,3.719,5.99,22.178,22.178,0,0,1,.625,13.44,26.623,26.623,0,0,1-5.047,9.826,32.467,32.467,0,0,1-5.3,5.246c-.7.542-1.249.944-1.636,1.2A3.644,3.644,0,0,1,367.338,284.855Z",
    fill: "#455a64"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_282",
    "data-name": "Group 282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_265",
    "data-name": "Group 265"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M79.943,404.29c2.528,3.167,6.968,1.786,8.931-.368s2.662-5.14,3.291-7.986c1.436-6.5,2.867-13.318,1.091-19.736a10.908,10.908,0,0,0-2.837-5.168,5.7,5.7,0,0,0-5.5-1.454c-2.235.743-3.508,3.059-4.4,5.241a46.78,46.78,0,0,0-3.353,20.33c.191,3.229.785,6.59,2.774,9.141",
    fill: "#e8505b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M79.943,404.29c2.528,3.167,6.968,1.786,8.931-.368s2.662-5.14,3.291-7.986c1.436-6.5,2.867-13.318,1.091-19.736a10.908,10.908,0,0,0-2.837-5.168,5.7,5.7,0,0,0-5.5-1.454c-2.235.743-3.508,3.059-4.4,5.241a46.78,46.78,0,0,0-3.353,20.33c.191,3.229.785,6.59,2.774,9.141"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_270",
    "data-name": "Group 270"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_269",
    "data-name": "Group 269"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M89.69,420.521a20.139,20.139,0,0,1,12.377-2.3c2.287.231,4.688.76,6.335,2.363s2.127,4.575.451,6.147a5.923,5.923,0,0,1-3.823,1.23c-3.3.169-6.995-.181-9.5,1.968-1.431,1.227-2.313,3.171-4.075,3.841a4.258,4.258,0,0,1-4.8-1.786,7.273,7.273,0,0,1-.866-5.324A8.2,8.2,0,0,1,89.69,420.521Z",
    fill: "#e8505b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_272",
    "data-name": "Group 272"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_271",
    "data-name": "Group 271"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M73.871,409.444c2.331-3.147,2.535-7.537,1.178-11.212a21.421,21.421,0,0,0-7.171-9.118,35.442,35.442,0,0,0-12.2-6.2,12.578,12.578,0,0,0-5.348-.566,5.564,5.564,0,0,0-4.272,2.966c-1.09,2.44.278,5.23,1.709,7.486a89.792,89.792,0,0,0,8.469,11.283c2.5,2.84,5.343,5.619,8.958,6.746s7.273.738,8.99-1.828",
    fill: "#e8505b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_275",
    "data-name": "Group 275"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_274",
    "data-name": "Group 274"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_273",
    "data-name": "Group 273"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M82.931,454.279a7.3,7.3,0,0,0,.115-1.519c.038-1.1.085-2.486.141-4.133a59.683,59.683,0,0,1,.545-6.086,46.575,46.575,0,0,1,1.743-7.25,26.286,26.286,0,0,1,3.227-6.665,13.593,13.593,0,0,1,4.352-4.106,12.871,12.871,0,0,1,3.791-1.448,7.24,7.24,0,0,0,1.486-.311,7.074,7.074,0,0,0-1.527.072,11.757,11.757,0,0,0-3.967,1.3,13.572,13.572,0,0,0-4.6,4.156,25.667,25.667,0,0,0-3.352,6.8,43.563,43.563,0,0,0-1.72,7.366,51.174,51.174,0,0,0-.417,6.153c-.021,1.753.019,3.169.057,4.147A6.989,6.989,0,0,0,82.931,454.279Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_278",
    "data-name": "Group 278"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    "data-name": "Group 277"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_276",
    "data-name": "Group 276"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M83.015,451.1a2.97,2.97,0,0,0,0-.7c-.034-.524-.077-1.186-.13-2-.114-1.733-.271-4.242-.374-7.346-.236-6.206-.241-14.792.2-24.258s1.289-18.016,2.161-24.164c.2-1.54.413-2.928.619-4.144s.356-2.269.524-3.12c.14-.8.254-1.454.345-1.972a2.99,2.99,0,0,0,.079-.7,2.9,2.9,0,0,0-.2.671l-.46,1.95c-.2.847-.4,1.893-.629,3.108s-.482,2.6-.711,4.14a227.117,227.117,0,0,0-2.348,24.2c-.44,9.486-.365,18.093-.015,24.308.158,3.108.383,5.618.571,7.347.1.809.183,1.467.248,1.989A2.983,2.983,0,0,0,83.015,451.1Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_280",
    "data-name": "Group 280"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_279",
    "data-name": "Group 279"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M82.015,434.553a13.289,13.289,0,0,0-.146-2.086c-.161-1.337-.467-3.263-.994-5.614a74.719,74.719,0,0,0-2.358-8.122,73.13,73.13,0,0,0-4.057-9.53,52.013,52.013,0,0,0-11.108-15.114,25.8,25.8,0,0,0-2.518-2.063c-.385-.286-.727-.573-1.071-.8l-.964-.579a13.389,13.389,0,0,0-1.827-1.014,62.588,62.588,0,0,1,6.082,4.775A54.843,54.843,0,0,1,73.9,409.484a78.17,78.17,0,0,1,4.072,9.439,83.915,83.915,0,0,1,2.469,8.033c.579,2.323.949,4.226,1.184,5.545A13.546,13.546,0,0,0,82.015,434.553Z",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Confetti"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_284",
    "data-name": "Group 284"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    "data-name": "Group 283"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M234.587,205.759c-1.844-6.534-10.336-5.9-10.336-5.9l.233,4.544c4.909-.846,7.96,4.907,7.96,4.907Z",
    fill: "#e8505b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_286",
    "data-name": "Group 286"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_285",
    "data-name": "Group 285"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M151.036,129.745c-4.584.486-5.132,6.242-5.132,6.242l3.068.364c-.005-3.382,4.194-4.765,4.194-4.765Z",
    fill: "#e8505b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_288",
    "data-name": "Group 288"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_287",
    "data-name": "Group 287"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M193.72,68.768c2.8,7.125,12.252,5.468,12.252,5.468l-.767-5.072c-5.413,1.5-9.476-4.618-9.476-4.618Z",
    fill: "#e8505b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_290",
    "data-name": "Group 290"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_289",
    "data-name": "Group 289"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M87.085,189.131c-4.584.487-5.132,6.242-5.132,6.242l3.068.364c-.005-3.382,4.195-4.765,4.195-4.765Z",
    fill: "#e8505b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_292",
    "data-name": "Group 292"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_291",
    "data-name": "Group 291"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M105.972,91.535c.666-4.562-4.773-6.52-4.773-6.52L100.085,87.9c3.277.835,3.575,5.246,3.575,5.246Z",
    fill: "#e8505b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_294",
    "data-name": "Group 294"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_293",
    "data-name": "Group 293"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M27.6,161.545c-.823,7.153,8.651,8.884,8.651,8.884l1.71-4.68c-5.685-.513-6.505-7.209-6.505-7.209Z",
    fill: "#e8505b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    "data-name": "Group 296"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_295",
    "data-name": "Group 295"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M252.779,127.032c4.6.262,6.075-5.328,6.075-5.328l-2.968-.857c-.543,3.339-4.911,4.023-4.911,4.023Z",
    fill: "#e8505b"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcess3);
export default __webpack_public_path__ + "static/media/process-3.d7c35aea17e4e70bde616570595995bf.svg";
export { ForwardRef as ReactComponent };